'use strict';

var popup = function() {
	$( '.popup' ).on( 'click', '.popup__close', function() {
		$( this ).parents( '.popup' ).hide();
		$( 'body' ).css( { 'overflow': 'auto' } );
	} );
};

